module.exports = __webpack_public_path__ + "static/media/changeLanguage.6fc3ba57.svg";